import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Contract } from "@/types/contract";

interface CurrentStatusProps {
  contract: Contract;
  formatCurrency: (value: number | null | undefined) => string;
  formatDate: (dateString: string | null | undefined) => string;
}

export function CurrentStatus({ contract, formatCurrency, formatDate }: CurrentStatusProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Current Contract Status</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="font-medium">Outstanding Balance:</span>
            <p>{formatCurrency(contract.remaining_balance)}</p>
          </div>
          <div>
            <span className="font-medium">Monthly Payment:</span>
            <p>{formatCurrency(contract.monthly_payment)}</p>
          </div>
          <div>
            <span className="font-medium">Term Remaining:</span>
            <p>{contract.term_remaining || 'N/A'}</p>
          </div>
        </div>
        
        {contract.has_balloon_payment && contract.balloon_payment_amount && (
          <>
            <Separator className="my-4" />
            <div className="grid grid-cols-2 gap-4">
              <div>
                <span className="font-medium">Current Balloon Amount:</span>
                <p>{formatCurrency(contract.balloon_payment_amount)}</p>
              </div>
              <div>
                <span className="font-medium">Balloon Due Date:</span>
                <p>{formatDate(contract.balloon_payment_due_date)}</p>
              </div>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}